import { LoadableRoute } from 'routes/utils/loadable';

export const PublicJobBoardContainer = LoadableRoute({
  loader: () =>
    import(/* webpackChunkName: "PublicJobBoard" */ './PublicJobBoard'),
});
